import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import ScheduleIcon from '@material-ui/icons/Schedule';
import DashboardIcon from '@material-ui/icons/Dashboard';
import StorageIcon from '@material-ui/icons/Storage';
import SettingsIcon from '@material-ui/icons/Settings';
import BusinessIcon from '@material-ui/icons/Business';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import ForumIcon from '@material-ui/icons/Forum';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {/* Solo lo nuestro: el resto del scaffold (Catálogo, APIs, Create,
                TechDocs, etc.) queda oculto del menú — no se llama nav.rest(). */}
            <SidebarItem icon={ScheduleIcon} to="/schedulers" text="Schedulers" />
            <SidebarItem icon={StorageIcon} to="/servicios" text="Servicios" />
            <SidebarItem icon={BusinessIcon} to="/clientes" text="Clientes" />
            <SidebarItem
              icon={DashboardIcon}
              to="/observabilidad"
              text="Observabilidad"
            />
            <SidebarItem
              icon={DeleteSweepIcon}
              to="/s3-mantenimiento"
              text="S3 · Mantenimiento"
            />
            <SidebarItem icon={ForumIcon} to="/menciones" text="Menciones" />
            <SidebarItem
              icon={AssessmentIcon}
              to="/reportes-discord"
              text="Reportes Discord"
            />
            <SidebarDivider />
            <SidebarItem
              icon={SettingsIcon}
              to="/servicios-config"
              text="Servicios · Config"
            />
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
